import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { motion } from 'framer-motion';
import SubjectFormFields from './SubjectFormFields';

const SubjectModal = ({
    open,
    onClose,
    onSubmit,
    subjectData,
    setSubjectData,
    exams,
    generateCode,
    codeManuallyEdited,
    setCodeManuallyEdited,
    title = "Add New Subject",
    submitButtonText = "Add Subject",
    submitButtonColor = "success"
}) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ m: 0, p: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <motion.div
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}
                    style={{ fontWeight: "bold", fontSize: "1.4rem", color: "#1976d2", display: "flex", gap: "8px", alignItems: "center" }}
                >
                    📚 {title}
                </motion.div>

                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{ position: "absolute", top: 8, right: 8, color: "red" }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <SubjectFormFields
                    subjectData={subjectData}
                    setSubjectData={setSubjectData}
                    exams={exams}
                    generateCode={generateCode}
                    codeManuallyEdited={codeManuallyEdited}
                    setCodeManuallyEdited={setCodeManuallyEdited}
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button variant="contained" color={submitButtonColor} onClick={onSubmit}>
                    {submitButtonText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SubjectModal;
